module.exports = __webpack_public_path__ + "img/Singapore.2bfd0204.gif";